import {assessChapterTypes} from '../settingsTypes';

const initialState = {
    allAssessmentChapters: [],
    loading: false,
    error: '',
    text: '',
    chapter:'',
    totalChaptersCount: 0,
    allChapters:[],
    errorchapterdelete:false,
    loadingchapterdelete:false,
    successchapterupdate: false,
    loadingchapterupdate: false,
    errorchapterupdate:false,
    successchapterdelete:false,
    errorchaptercreate: '',
    successchaptercreate: false,
}

export function chapterReducer(state = initialState, action){
    switch (action.type){
        case assessChapterTypes.CREATE_PAGE_REFRESH:
            return {
                ...state,
                allAssessmentChapters: [],
                loading: false,
                error: '',
                text: '',
                chapter:'',
                totalChaptersCount:0,
                allChapters:[],
                errorchapterdelete:false,
                loadingchapterdelete:false,
                successchapterupdate: false,
                loadingchapterupdate: false,
                errorchapterupdate:false,
                successchapterdelete:false,
                errorchaptercreate: '',
                successchaptercreate: false,
            }
        //Chapter retrieve request sending
        case assessChapterTypes.GET_ALL_ASSESSMENT_CHAPTERS:
            return {
                ...state,
                loading: true,
                text: 'Get all the assessment chapters'
            }
        case assessChapterTypes.GET_ALL_ASSESSMENT_CHAPTERS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case assessChapterTypes.GET_ALL_ASSESSMENT_CHAPTERS_SUCCESS:
            return {
                ...state,
                loading: false,
                allAssessmentChapters: action.chapters.chapters,
                totalChaptersCount: action.chapters.total_count
            }
        case assessChapterTypes.GET_ALL_ASSESSMENT_CHAPTERS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        //Chapter creation request sending
        case assessChapterTypes.CREATE_CHAPTER_REQUEST:
            return {
                ...state,
                errorchaptercreate: '',
                successchaptercreate: false,
                loading: true
            }
        case assessChapterTypes.CREATE_CHAPTER_SUCCESS:
            var temp = state.allChapters;
            temp.push(action.chapters)
            return {
                ...state,
                allChapters: temp,
                chapter: action.chapters.chapter_id,
                successchaptercreate: true,
                loading: false
            }
        case assessChapterTypes.CREATE_CHAPTER_FAILURE:
            return {
                ...state,
                errorchaptercreate: action.error,
                loading: false
            }  
        //Chapter deletion request sending   
        case assessChapterTypes.DELETE_CHAPTER_REQUEST:
            return {
            ...state,
            errorchapterdelete: '',
            successchapterdelete: false,
            loading: true,
            };
        case assessChapterTypes.DELETE_CHAPTER_SUCCESS:
            return {
            ...state,
            successchapterdelete: true,
            loading: false,
            };
        case assessChapterTypes.DELETE_CHAPTER_FAILURE:
            return {
            ...state,
            errorchapterdelete: action.error,
            loading: false,
            };
        //Chapter updation request sending
        case assessChapterTypes.UPDATE_CHAPTER_REQUEST:
            return {
            ...state,
            errorchapterupdate:'',
            successchapterupdate: false,
            loading: true,
            };
        case assessChapterTypes.UPDATE_CHAPTER_SUCCESS:
            return {
            ...state,
            successchapterupdate: true,
            loading: false,
            };
        case assessChapterTypes.UPDATE_CHAPTER_FAILURE:
            return {
            ...state,
            errorchapterupdate: action.error,
            loading: false,
            };     
        default:
            return state
    }
}
